import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import LookupValue from "../../../models/patient-chart/lookupValue";
import { ConfigurationService } from "../../../providers/configuration/configuration.service";
import { BenefitResponse } from "./Responses/BenefitResponse";

@Injectable()
export class BenefitsServiceProvider {
  hospiceElectionDate: any = "";
  url: string;
  editMode: BehaviorSubject<string> = new BehaviorSubject<string>("add");

  payerNames: LookupValue[];
  payerLevelTypes: LookupValue[];

  public currentPrimaryBenefit: BenefitResponse;

  public changeCurrentSelectedPayerRecertificationInterval: Subject<string> =
    new Subject<string>();
  public recertificationInterval: string = "";

  private changeBenefit: Subject<BenefitResponse> =
    new Subject<BenefitResponse>();
  public benefitsTypesLookUpValues: LookupValue[];

  constructor(public http: HttpClient, private config: ConfigurationService) {
    if (
      this.config.getConfig().isLocal &&
      this.config.getConfig().localEndpoints.patientBenefits
    ) {
      this.url = this.config.getConfig().localEndpoints.patientBenefits;
    } else {
      this.url = this.config.getConfig().apiUrl;
    }

    this.changeBenefit.subscribe((benefit: BenefitResponse) => {
      // TODO: Change this to accommodate multiple benefits in a request
      if (
        benefit.payerLevelTypeId === this.getPayerLevelTypeId("primary") ||
        benefit.payerLevelTypeId === 1
      ) {
        this.currentPrimaryBenefit = benefit;
      }
    });

    this.changeCurrentSelectedPayerRecertificationInterval.subscribe(
      (recertificationInterval: string) => {
        this.recertificationInterval = this.translateRecertificationInterval(
          recertificationInterval
        );
      }
    );
  }

  getBenefitsTypes() {
    return this.http.get(`${this.url}/patient-benefits/lookups/payer-types`);
  }
  updateEditMode(mode) {
    this.editMode.next(mode);
  }
  getEditMode() {
    return this.editMode.asObservable();
  }

  getPayerNames(id) {
    return this.http.get(
      `${this.url}/patient-benefits/lookups/payer-types/${id}/payer-names`
    );
  }

  saveBenefit(benefitFormValue, patientId) {
    return this.http.post(
      `${this.url}/benefits/${patientId}`,
      benefitFormValue
    );
  }

  getActiveBenefit(patientId) {
    return this.http.get(`${this.url}/patients/${patientId}/benefits`);
  }

  getPatientBenefitLookUpValues() {
    return this.http.get(`${this.url}/patient-benefits/lookups`);
  }

  getCurrentBenefits() {}

  updateBenefit(benefits: any) {
    if (Array.isArray(benefits)) {
      for (let benefit of benefits) {
        this.changeBenefit.next(benefit);
      }
    } else {
      this.changeBenefit.next(benefits);
    }
  }

  clearCurrentBenefits() {
    this.currentPrimaryBenefit = null;
  }

  updateRecertificationInterval(recertificationInterval: string) {
    this.changeCurrentSelectedPayerRecertificationInterval.next(
      recertificationInterval
    );
  }

  public getPayerLevelTypeId(description: string): number {
    let primaryPayerLevel = null;
    if (this.payerLevelTypes) {
      this.payerLevelTypes.filter(function (payerLevelType: LookupValue) {
        if (
          payerLevelType.description.toLocaleLowerCase() ===
          description.toLocaleLowerCase()
        ) {
          primaryPayerLevel = payerLevelType.id;
        }
      });
    }
    return primaryPayerLevel;
  }

  public getPayerTypeId(description: string): number {
    let payerTypeId = null;
    if (this.benefitsTypesLookUpValues) {
      this.benefitsTypesLookUpValues.filter(function (payerType: LookupValue) {
        if (
          payerType.description.toLocaleLowerCase() ===
          description.toLocaleLowerCase()
        ) {
          payerTypeId = payerType.id;
        }
      });
    }
    return payerTypeId;
  }

  getPayerBenefits(patientId) {
    return this.http.get(`${this.url}/benefits/${patientId}/getActiveBenefit`);
  }

  public translateRecertificationInterval(
    recertificationInterval: string,
    transformId: boolean = true
  ) {
    if (transformId) {
      switch (recertificationInterval) {
        case "1":
          return "90-90-60";
        case "2":
          return "90-90-30";
        case "3":
          return "60-60-60";
        case "4":
          return "Every six months";
      }
    } else {
      switch (recertificationInterval) {
        case "90-90-60":
          return "1";
        case "90-90-30":
          return "2";
        case "60-60-60":
          return "3";
        case "Every six months":
          return "4";
      }
    }
  }

  public getPayerNamesByPayerTypeName(payerTypeName: string) {
    return this.http.get(
      `${this.url}/payers/lookups/payer-type-name/${payerTypeName}/payer-names`
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/benefits/benefitsServiceProvider.ts